module.exports = __webpack_public_path__ + "img/full5-min.9f46bde2.png";